import React, { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

/**
 * Renders nothing. Registers the current section's update payload getter with the context
 * so the layout can build newDsokSettings when Update is confirmed.
 * Place inside <Formik> on each section page that supports update.
 *
 * @param {string} sectionId - Section id (e.g. "settings", "ui-settings", "locations", "devices")
 * @param {function(Object): *} getPayload - (formValues) => section payload to replace at dsokSettings path
 */
const DsokCustomerDetailSectionRegister = ({ sectionId, getPayload }) => {
  const { values } = useFormikContext();
  const {
    registerSectionUpdatePayload,
    unregisterSectionUpdatePayload,
  } = useDsokCustomerDetail();
  const payloadRef = useRef(null);

  payloadRef.current = getPayload ? getPayload(values) : null;

  useEffect(() => {
    if (!sectionId) return;
    registerSectionUpdatePayload(sectionId, () => payloadRef.current);
    return () => unregisterSectionUpdatePayload(sectionId);
  }, [sectionId, registerSectionUpdatePayload, unregisterSectionUpdatePayload]);

  return null;
};

export default DsokCustomerDetailSectionRegister;
